<template>
  <section class="bm-title">
    <header class="bm-title__head">
      <div class="bm-title__crumb">
        <button @click="$emit('back')">‹ 返回</button>
        <span>
          云库工作台　›　批量修改　›　
          <strong>库存(SKU)</strong>
        </span>
        <a>帮助教程</a>
      </div>
      <h1>批量修改库存(SKU)</h1>
      <nav>
        <button class="mode-range" :class="{ active: mode === 'range' }" @click="switchMode('range')">
          按范围修改
        </button>
        <button class="mode-goods" :class="{ active: mode === 'goods' }" @click="switchMode('goods')">
          按商品修改
        </button>
      </nav>
    </header>
    <main class="bm-title__body">
      <section v-if="mode === 'range'" class="bm-title__filter">
        <div v-for="field in fields" :key="field.key" class="bm-title__field">
          <label>{{ field.label }}</label>
          <el-select v-if="field.select" v-model="filterValues[field.key]" class="bm-title__filter-select">
            <el-option label="全部" value="" />
            <el-option v-for="o in optionsFor(field.key)" :key="o.value" :label="o.label" :value="o.value" />
          </el-select>
          <div v-else-if="field.range" class="bm-title__date-range">
            <input v-model="addTime[0]" type="date" class="bm-title__date-input" />
            <span>—</span>
            <input v-model="addTime[1]" type="date" class="bm-title__date-input" />
          </div>
          <el-select
            v-else-if="field.key === 'group_id' || field.key === 'child_group_id'"
            v-model="filterValues[field.key]"
            class="bm-title__filter-select"
            @change="field.key === 'group_id' && onGroupChange()">
            <el-option label="全部" value="" />
            <el-option v-for="o in optionsFor(field.key)" :key="o.value" :label="o.label" :value="o.value" />
          </el-select>
          <input v-else v-model="filterValues[field.key]" :placeholder="field.placeholder" />
        </div>
        <footer>
          <div>
            <button @click="previewBatch">查询</button>
            <button class="plain" @click="reset">重置</button>
          </div>
        </footer>
      </section>
      <section v-else class="bm-title__picked">
        <button @click="openSelector">选择商品</button>
        <span>{{ selected.length ? '已选择 ' + selected.length + ' 个商品' : '请先选择需要修改的商品' }}</span>
      </section>
      <section class="bm-title__methods sku-methods">
        <header>
          <p></p>
          库存范围
        </header>
        <div class="sku-scope-options">
          <div class="sku-scope-row-main">
            <el-checkbox :value="form.stockScope === 'all'" @change="toggleStockScope('all', $event)">
              所有SKU
            </el-checkbox>
            <el-checkbox :value="form.stockScope === 'gt_zero'" @change="toggleStockScope('gt_zero', $event)">
              库存大于0的SKU
            </el-checkbox>
            <el-checkbox :value="form.stockScope === 'eq_zero'" @change="toggleStockScope('eq_zero', $event)">
              库存为0的SKU
            </el-checkbox>
            <el-checkbox :value="form.stockScope === 'range'" @change="toggleStockScope('range', $event)">
              库存区间的SKU
              <span class="stock-range-inline">
                <el-input-number
                  class="price-number-input"
                  v-model="form.stockScopeMin"
                  :disabled="form.stockScope !== 'range'"
                  :min="0"
                  :max="999999"
                  :step="1"
                  :precision="0"
                  controls-position="right"
                  placeholder="最小库存" />
                <span>至</span>
                <el-input-number
                  class="price-number-input"
                  v-model="form.stockScopeMax"
                  :disabled="form.stockScope !== 'range'"
                  :min="0"
                  :max="999999"
                  :step="1"
                  :precision="0"
                  controls-position="right"
                  placeholder="最大库存" />
                <span>件</span>
              </span>
            </el-checkbox>
          </div>

          <div class="sku-scope-row-detail">
            <div class="sku-scope-mode">
              <el-checkbox
                :value="
                  (form.stockScope === 'all' && form.allSkuMode === 'all_spec') ||
                  (form.stockScope === 'gt_zero' && form.gtZeroSkuMode === 'all_spec') ||
                  (form.stockScope === 'eq_zero' && form.eqZeroSkuMode === 'all_spec') ||
                  (form.stockScope === 'range' && form.rangeSkuMode === 'all_spec')
                "
                :disabled="!form.stockScope"
                @change="onSkuModeChange('all_spec', $event)">
                所有的SKU规格名称
              </el-checkbox>
              <el-checkbox
                :value="
                  (form.stockScope === 'all' && form.allSkuMode === 'selected_spec') ||
                  (form.stockScope === 'gt_zero' && form.gtZeroSkuMode === 'selected_spec') ||
                  (form.stockScope === 'eq_zero' && form.eqZeroSkuMode === 'selected_spec') ||
                  (form.stockScope === 'range' && form.rangeSkuMode === 'selected_spec')
                "
                :disabled="!form.stockScope"
                @change="onSkuModeChange('selected_spec', $event)">
                选择的SKU规格名称
              </el-checkbox>
            </div>
            <div class="sku-scope-config">
              <el-select class="bm-title__select" v-model="currentSpecField" :disabled="!isSelectedSpecMode">
                <el-option label="SKU规格名称包含关键字" value="spec_name:contains" />
                <el-option label="SKU规格名称不包含关键字" value="spec_name:not_contains" />
                <el-option label="SKU规格名称精确为" value="spec_name:exact" />
                <el-option label="SKU备注包含关键字" value="spec_remark:contains" />
                <el-option label="SKU备注不包含关键字" value="spec_remark:not_contains" />
                <el-option label="SKU备注精确为" value="spec_remark:exact" />
              </el-select>
              <el-input
                v-model="currentKeywords"
                :disabled="!isSelectedSpecMode"
                maxlength="1000"
                placeholder="多个关键字用逗号隔开，最多输入100个" />
              <span v-if="currentKeywordCount" class="sku-keyword-count">{{ currentKeywordCount }}/100</span>
            </div>
          </div>

          <slot name="last-plan-sample"></slot>
        </div>
      </section>
      <section class="bm-title__methods price-methods">
        <header>
          <p></p>
          修改内容
        </header>
        <article>
          <div
            v-for="item in operations"
            :key="item.value"
            class="price-method"
            :class="{ active: form.operation === item.value, disabled: item.disabled }">
            <div class="price-method-title">
              <el-radio
                v-model="form.operation"
                :label="item.value"
                :disabled="item.disabled"
                @change="onOperationChange">
                {{ item.label }}
              </el-radio>
            </div>
            <div class="price-method-fields">
              <template v-if="item.value === 'set'">
                <span>新库存</span>
                <el-input-number
                  class="price-number-input"
                  v-model="form.newStock"
                  :min="0"
                  :max="999999"
                  :step="1"
                  :precision="0"
                  controls-position="right"
                  placeholder="请输入库存" />
                <span>件</span>
              </template>
              <template v-else-if="item.value === 'formula'">
                <div class="price-formula-row">
                  <span>库存 ×</span>
                  <el-input-number
                    class="price-number-input"
                    v-model="form.percent"
                    :min="-100"
                    :max="1000"
                    :step="1"
                    controls-position="right"
                    placeholder="百分比%" />
                  <span>% +</span>
                  <el-input-number
                    class="price-number-input"
                    v-model="form.delta"
                    :min="0"
                    :max="999999"
                    :step="1"
                    :precision="0"
                    controls-position="right"
                    placeholder="增加件数" />
                  <span>件 -</span>
                  <el-input-number
                    class="price-number-input"
                    v-model="form.subtract"
                    :min="0"
                    :max="999999"
                    :step="1"
                    :precision="0"
                    controls-position="right"
                    placeholder="减少件数" />
                  <span>件（如果计算有小数自动向上取整）</span>
                </div>
              </template>
              <template v-else-if="item.value === 'increase'">
                <el-input-number
                  class="price-number-input"
                  v-model="form.increaseStock"
                  :min="0"
                  :max="999999"
                  :step="1"
                  :precision="0"
                  controls-position="right"
                  placeholder="新增量" />
                <span>件，且不高于</span>
                <el-input
                  class="price-number-input"
                  v-model="form.maxStock"
                  type="number"
                  min="0"
                  max="999999"
                  step="1"
                  placeholder="最高库存" />
                <span>件（为空时不限制最高库存；库存高于最高库存时将修改为最高库存数）</span>
              </template>
              <template v-else-if="item.value === 'decrease'">
                <el-input-number
                  class="price-number-input"
                  v-model="form.decreaseStock"
                  :min="0"
                  :max="999999"
                  :step="1"
                  :precision="0"
                  controls-position="right"
                  placeholder="减少量" />
                <span>件，且不低于</span>
                <el-input
                  class="price-number-input"
                  v-model="form.minStock"
                  type="number"
                  min="0"
                  max="999999"
                  step="1"
                  placeholder="最低库存" />
                <span>件（为空时不限制最低库存；库存低于最低库存时将修改为最低库存数）</span>
              </template>
            </div>
          </div>
        </article>
      </section>
      <section v-if="preview" class="bm-title__preview">
        <header>
          预览：共
          <b>{{ preview.product_count || preview.total || previewGoods.length || 0 }}</b>
          个商品，跳过
          <b>{{ preview.skipped_product_count || preview.skipped_product_count_total || 0 }}</b>
          个商品，失败
          <b>{{ preview.failed_product_count || preview.failed_count || 0 }}</b>
          个商品
        </header>
        <table>
          <thead>
            <tr>
              <th>商品信息</th>
              <!-- <th>价格信息</th> -->
              <th>SKU信息</th>
              <th>状态</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in previewGoods"
              :key="String(item.product_id || index)"
              :class="{ 'is-excluded': excludedProductIds.includes(String(item.product_id)) }">
              <td>
                <el-image
                  class="bm-title__image"
                  :src="imageOf(item)"
                  fit="cover"
                  :preview-src-list="[imageOf(item)]" />
                <div>
                  <p>{{ item.title || item.product_title }}</p>
                  <div class="preview-meta">
                    <small>商品ID：{{ item.product_id }}</small>
                    <small>来源ID：{{ item.source_product_id || '无数据' }}</small>
                    <small>数据源：{{ sourceLabel(item.source_web) }}</small>
                  </div>
                </div>
              </td>
              <!-- <td class="price-cell">
                <div>
                  修改前价格：{{
                    previewPrice(item, 'old_stock')
                  }}
                </div>
                <div>
                  修改后价格：{{
                    previewPrice(item, 'new_stock')
                  }}
                </div>
              </td> -->
              <td>
                <details class="bm-title__sku-list" :open="item._skuOpen">
                  <summary @click.prevent="loadSku(item)">
                    {{ item._skuLoading ? '加载中' : 'SKU明细' }}
                  </summary>
                  <table>
                    <thead>
                      <tr>
                        <th>规格</th>
                        <th>原库存</th>
                        <th>新库存</th>
                        <th>状态</th>
                        <th>错误信息</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="sku in skuRows(item)"
                        :key="String(sku.sku_id)"
                        :class="{
                          'sku-matched-row': sku.matched === true && !sku.error_msg,
                          'sku-unmatched-row': sku.matched === false,
                          'sku-failed-row': sku.matched === true && sku.error_msg
                        }">
                        <td>{{ sku.sku_spec_text || sku.spec_text || '默认规格' }}</td>
                        <td>{{ sku.old_stock != null ? sku.old_stock : '无数据' }}</td>
                        <td>{{ sku.matched ? (sku.new_stock != null ? sku.new_stock : '计算失败') : '不修改' }}</td>
                        <td>{{ sku.status_text || (sku.matched ? '命中，已计算' : '未命中，不修改') }}</td>
                        <td>{{ sku.error_msg || '—' }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <p v-if="!skuRows(item).length">暂无SKU明细</p>
                  <p v-if="item._skuError" class="sku-error">{{ item._skuError }}</p>
                </details>
              </td>
              <td>
                {{ item.status_text || item.status || '待处理' }}
                <span v-if="item.error_msg">{{ item.error_msg }}</span>
              </td>
              <td class="action-cell">
                <button @click="toggleExclude(item)">
                  {{ excludedProductIds.includes(String(item.product_id)) ? '恢复修改' : '排除修改' }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <footer class="bm-title__pagination">
          <button :disabled="previewPage.page <= 1" @click="previewBatchPage(previewPage.page - 1)">上一页</button>
          <span>第 {{ previewPage.page }} / {{ pageCount }} 页</span>
          <button :disabled="previewPage.page >= pageCount" @click="previewBatchPage(previewPage.page + 1)">
            下一页
          </button>
          <select v-model.number="previewPage.limit" @change="previewBatchPage(1)">
            <option :value="10">10条/页</option>
            <option :value="20">20条/页</option>
            <option :value="50">50条/页</option>
          </select>
        </footer>
      </section>
      <p v-if="preview && preview.warnings && preview.warnings.length" class="bm-title__warnings">
        {{ preview.warnings.map((item) => item.message + '（商品ID：' + item.product_id + '）').join('；') }}
      </p>
    </main>
    <footer class="bm-title__bottom">
      <button class="preview" :disabled="previewLoading" @click="previewBatch">
        {{ previewLoading ? '预览中' : '修改内容预览' }}
      </button>
      <button class="start" :disabled="!canCreate || submitting" @click="createBatch">
        {{ submitting ? '提交中' : '开始批量修改' }}
      </button>
    </footer>
    <div v-if="selecting" class="bm-title__mask">
      <div class="bm-title__select-modal">
        <header>
          <strong>选择修改商品</strong>
          <button @click="selecting = false">×</button>
        </header>
        <nav>
          <button :class="{ active: selectorTab === 'all' }" @click="switchSelectorTab('all')">选择商品</button>
          <button :class="{ active: selectorTab === 'selected' }" @click="switchSelectorTab('selected')">已选择</button>
        </nav>
        <div class="bm-title__selector-toolbar">
          <div class="bm-title__select-filter">
            <el-select
              v-model="selectorFilters.group_id"
              popper-class="bm-title__select-popper"
              class="bm-title__group-select"
              @change="loadSelectorGroups">
              <el-option label="全部分组" value="" />
              <el-option v-for="g in groupList" :key="g.id" :label="g.name || g.group_name" :value="g.id" />
            </el-select>
            <el-select
              v-model="selectorFilters.child_group_id"
              popper-class="bm-title__select-popper"
              class="bm-title__group-select"
              @change="loadGoods(1)">
              <el-option label="全部子分组" value="" />
              <el-option v-for="g in selectorChildGroups" :key="g.id" :label="g.name || g.group_name" :value="g.id" />
            </el-select>
            <input v-model="selectorFilters.source_product_id" placeholder="来源ID" />
            <input v-model="selectorFilters.keyword" placeholder="商品标题" />
            <button @click="loadGoods(1)">查询</button>
          </div>
          <div class="bm-title__selector-pagination">
            <button :disabled="selectorPage.page <= 1" @click="loadGoods(selectorPage.page - 1)">上一页</button>
            <span>{{ selectorPage.page }} / {{ Math.max(1, Math.ceil(selectorPage.total / selectorPage.limit)) }}</span>
            <button
              :disabled="selectorPage.page >= Math.max(1, Math.ceil(selectorPage.total / selectorPage.limit))"
              @click="loadGoods(selectorPage.page + 1)">
              下一页
            </button>
            <el-select
              v-model="selectorPage.limit"
              popper-class="bm-title__select-popper"
              class="bm-title__page-size"
              @change="loadGoods(1)">
              <el-option v-for="n in [10, 20, 50]" :key="n" :label="n + '条/页'" :value="n" />
            </el-select>
          </div>
          <label class="bm-title__select-all">
            <el-checkbox :value="selectorPageAllSelected" @change="togglePageGoods" />
            全选
          </label>
        </div>
        <main>
          <button
            v-for="g in displayedGoods"
            :key="g.product_id"
            :class="{ selected: selected.includes(String(g.product_id)) }"
            @click="toggleGood(g.product_id)">
            <el-checkbox
              :value="selected.includes(String(g.product_id))"
              @click.native.stop
              @change="toggleGood(g.product_id)" />
            <img :src="imageOf(g)" alt="商品主图" />
            <span>{{ g.title || g.product_title }}</span>
            <small>{{ priceRange(g) }}</small>
          </button>
        </main>
        <footer>
          <span>已选 {{ selected.length }} 个商品</span>
          <button class="plain" @click="selecting = false">取消</button>
          <button @click="selecting = false">确定</button>
        </footer>
      </div>
    </div>
  </section>
</template>
<script>
import {
  previewCloudSkuStockBatch,
  previewCloudSkuStockBatchSkus,
  createCloudSkuStockBatch
} from '@/api/main/cloudBatchEdit'
import { cloudProductGroups, cloudProductList } from '@/api/main/ucenter'
const fields = [
  { key: 'group_id', label: '分组', placeholder: '请选择分组' },
  { key: 'child_group_id', label: '子分组', placeholder: '请选择子分组' },
  { key: 'created_range', label: '导入时间', range: true },
  { key: 'source_product_id', label: '来源ID', placeholder: '请输入来源ID' },
  { key: 'sku_status', label: 'SKU替换状态', select: true },
  { key: 'sku_mark_status', label: '商品标记状态', select: true },
  { key: 'ai_title_status', label: '标题替换状态', select: true },
  { key: 'source_web', label: '数据源', select: true }
]
export default {
  name: 'BatchModifyStock',
  data() {
    return {
      mode: 'range',
      fields,
      addTime: [],
      groupList: [],
      childGroupList: [],
      statusOptions: {
        sku_status: [
          { label: '待替换', value: 1 },
          { label: '已替换', value: 2 },
          { label: '找不到', value: 3 }
        ],
        sku_mark_status: [
          { label: '未标记', value: 1 },
          { label: '已标记', value: 2 },
          { label: '找不到', value: 3 }
        ],
        ai_title_status: [
          { label: '待替换', value: 1 },
          { label: '已替换', value: 2 },
          { label: '异常', value: 9 }
        ],
        source_web: [
          { value: 9, label: '星好货' },
          { value: 3, label: 'TB' },
          { value: 4, label: 'PDD' },
          { value: 2, label: '1688' },
          { value: 5, label: 'DY' },
          { value: 6, label: 'WX' }
        ]
      },
      filterValues: {
        group_id: '',
        child_group_id: '',
        source_product_id: '',
        sku_status: '',
        sku_mark_status: '',
        ai_title_status: '',
        source_web: ''
      },
      selecting: false,
      selectorTab: 'all',
      selectorPage: { page: 1, limit: 20, total: 0 },
      selectorFilters: { group_id: '', child_group_id: '', source_product_id: '', keyword: '' },
      selectorChildGroups: [],
      selected: [],
      selectedGoods: [],
      goods: [],
      preview: null,
      previewGoods: [],
      previewPage: { page: 1, limit: 20, total: 0 },
      excludedProductIds: [],
      previewKey: '',
      previewLoading: false,
      submitting: false,
      form: {
        productIds: '',
        keyword: '',
        stockScope: 'all',
        specField: 'spec_name:contains',
        specMode: 'contains',
        keywords: '',
        allSpecField: 'spec_name:contains',
        allKeywords: '',
        gtZeroSpecField: 'spec_name:contains',
        gtZeroKeywords: '',
        eqZeroSpecField: 'spec_name:contains',
        eqZeroKeywords: '',
        rangeSpecField: 'spec_name:contains',
        rangeKeywords: '',
        allSkuMode: 'all_spec',
        gtZeroSkuMode: 'all_spec',
        eqZeroSkuMode: 'all_spec',
        rangeSkuMode: 'all_spec',
        stockScopeMin: 0,
        stockScopeMax: 100,
        operation: 'set',
        newStock: '',
        increaseStock: '',
        decreaseStock: '',
        percent: '0',
        subtract: '0',
        delta: '0',
        maxStock: '',
        minStock: '',
        guardMinStockEnabled: false,
        guardMaxStockEnabled: false,
        guardMinStock: '',
        guardMaxStock: ''
      },
      scopes: [
        { value: 'all', label: '所有SKU' },
        { value: 'gt_zero', label: '库存大于0的SKU' },
        { value: 'eq_zero', label: '库存为0的SKU' },
        { value: 'range', label: '库存区间' }
      ],
      operations: [
        { value: 'set', label: '使用新库存' },
        { value: 'formula', label: '使用公式' },
        { value: 'increase', label: '新增库存' },
        { value: 'decrease', label: '减少库存' }
      ]
    }
  },
  watch: {
    form: {
      deep: true,
      handler() {
        this.invalidate()
      }
    },
    filterValues: {
      deep: true,
      handler() {
        this.invalidate()
      }
    },
    addTime: {
      deep: true,
      handler() {
        this.invalidate()
      }
    },
    selected: {
      deep: true,
      handler() {
        this.invalidate()
      }
    },
    excludedProductIds: {
      deep: true,
      handler() {
        this.invalidate()
      }
    }
  },
  computed: {
    imageOf() {
      return (g) => g.main_image || g.image_url || (Array.isArray(g.main_images) && g.main_images[0]) || ''
    },
    loadSku() {
      return (item) => {
        const id = String(item.product_id)
        if (item._skuOpen) {
          this.$set(item, '_skuOpen', false)
          return
        }
        this.$set(item, '_skuLoading', true)
        const p = this.buildPayload()
        previewCloudSkuStockBatchSkus({
          ...p,
          product_id: id
        })
          .then((r) => {
            const d = (r.data && (r.data.data || r.data)) || {}
            this.$set(item, '_skus', Array.isArray(d) ? d : d.skus || d.items || d.list || [])
            this.$set(item, '_skuOpen', true)
          })
          .catch(() => this.$set(item, '_skuError', 'SKU查询失败'))
          .finally(() => this.$set(item, '_skuLoading', false))
      }
    },
    displayedGoods() {
      if (this.selectorTab === 'selected') {
        const s = (this.selectorPage.page - 1) * this.selectorPage.limit
        return this.selectedGoods.slice(s, s + this.selectorPage.limit)
      }
      return this.goods
    },
    selectorPageAllSelected() {
      return (
        this.displayedGoods.length > 0 && this.displayedGoods.every((g) => this.selected.includes(String(g.product_id)))
      )
    },
    canCreate() {
      return !!this.preview && this.previewKey === this.payloadKey()
    },
    pageCount() {
      return Math.max(1, Math.ceil(this.previewPage.total / this.previewPage.limit))
    },
    keywordCount() {
      return this.form.keywords
        .split(/[,，\r\n]+/)
        .map((v) => v.trim())
        .filter(Boolean)
        .filter((v, i, a) => a.indexOf(v) === i).length
    },
    allKeywordCount() {
      return this.countKeywords(this.form.allKeywords)
    },
    gtZeroKeywordCount() {
      return this.countKeywords(this.form.gtZeroKeywords)
    },
    eqZeroKeywordCount() {
      return this.countKeywords(this.form.eqZeroKeywords)
    },
    rangeKeywordCount() {
      return this.countKeywords(this.form.rangeKeywords)
    },
    currentSpecField: {
      get() {
        if (this.form.stockScope === 'all') return this.form.allSpecField
        if (this.form.stockScope === 'gt_zero') return this.form.gtZeroSpecField
        if (this.form.stockScope === 'eq_zero') return this.form.eqZeroSpecField
        if (this.form.stockScope === 'range') return this.form.rangeSpecField
        return 'spec_name:contains'
      },
      set(val) {
        if (this.form.stockScope === 'all') this.form.allSpecField = val
        if (this.form.stockScope === 'gt_zero') this.form.gtZeroSpecField = val
        if (this.form.stockScope === 'eq_zero') this.form.eqZeroSpecField = val
        if (this.form.stockScope === 'range') this.form.rangeSpecField = val
      }
    },
    currentKeywords: {
      get() {
        if (this.form.stockScope === 'all') return this.form.allKeywords
        if (this.form.stockScope === 'gt_zero') return this.form.gtZeroKeywords
        if (this.form.stockScope === 'eq_zero') return this.form.eqZeroKeywords
        if (this.form.stockScope === 'range') return this.form.rangeKeywords
        return ''
      },
      set(val) {
        if (this.form.stockScope === 'all') this.form.allKeywords = val
        if (this.form.stockScope === 'gt_zero') this.form.gtZeroKeywords = val
        if (this.form.stockScope === 'eq_zero') this.form.eqZeroKeywords = val
        if (this.form.stockScope === 'range') this.form.rangeKeywords = val
      }
    },
    currentKeywordCount() {
      if (this.form.stockScope === 'all') return this.allKeywordCount
      if (this.form.stockScope === 'gt_zero') return this.gtZeroKeywordCount
      if (this.form.stockScope === 'eq_zero') return this.eqZeroKeywordCount
      if (this.form.stockScope === 'range') return this.rangeKeywordCount
      return 0
    },
    isSelectedSpecMode() {
      if (this.form.stockScope === 'all') return this.form.allSkuMode === 'selected_spec'
      if (this.form.stockScope === 'gt_zero') return this.form.gtZeroSkuMode === 'selected_spec'
      if (this.form.stockScope === 'eq_zero') return this.form.eqZeroSkuMode === 'selected_spec'
      if (this.form.stockScope === 'range') return this.form.rangeSkuMode === 'selected_spec'
      return false
    }
  },
  created() {
    this.loadGroups()
  },
  methods: {
    onOperationChange(operation) {
      const defaults = {
        set: { newStock: '' },
        formula: { percent: '0', delta: '0' },
        increase: { increaseStock: '0', maxStock: '' },
        decrease: { decreaseStock: '0', minStock: '' }
      }
      Object.keys(defaults[operation] || {}).forEach((key) => {
        if (this.form[key] === '' || this.form[key] === null || this.form[key] === undefined)
          this.$set(this.form, key, defaults[operation][key])
      })
    },
    toggleStockScope(value, checked) {
      if (checked) {
        this.form.stockScope = value
        this.form.allSpecField = 'spec_name:contains'
        this.form.allKeywords = ''
        this.form.gtZeroSpecField = 'spec_name:contains'
        this.form.gtZeroKeywords = ''
        this.form.eqZeroSpecField = 'spec_name:contains'
        this.form.eqZeroKeywords = ''
        this.form.rangeSpecField = 'spec_name:contains'
        this.form.rangeKeywords = ''
        if (value === 'all') this.form.allSkuMode = 'all_spec'
        if (value === 'gt_zero') this.form.gtZeroSkuMode = 'all_spec'
        if (value === 'eq_zero') this.form.eqZeroSkuMode = 'all_spec'
        if (value === 'range') this.form.rangeSkuMode = 'all_spec'
      }
      this.invalidate()
    },
    onSkuModeChange(mode, checked) {
      if (checked && this.form.stockScope) {
        if (this.form.stockScope === 'all') this.form.allSkuMode = mode
        if (this.form.stockScope === 'gt_zero') this.form.gtZeroSkuMode = mode
        if (this.form.stockScope === 'eq_zero') this.form.eqZeroSkuMode = mode
        if (this.form.stockScope === 'range') this.form.rangeSkuMode = mode
        this.invalidate()
      }
    },
    toggleChild(field, value, checked) {
      if (checked) this.form[field] = value
    },
    countKeywords(value) {
      return String(value || '')
        .split(/[,，\r\n]+/)
        .map((v) => v.trim())
        .filter(Boolean)
        .filter((v, i, a) => a.indexOf(v) === i).length
    },
    skuRows(item) {
      return item.skus || item.sku_list || item._skus || []
    },
    previewPrice(item, key) {
      if (item[key] != null) return item[key]
      const rows = this.skuRows(item)
      if (!rows.length) return '无数据'
      const values = rows.map((row) => row[key]).filter((value) => value != null && value !== '')
      if (!values.length) return '无数据'
      if (values.length === 1 || values.every((value) => String(value) === String(values[0]))) return values[0]
      return `${values[0]} ~ ${values[values.length - 1]}`
    },
    sourceLabel(value) {
      const labels = { 9: '星好货', 3: 'TB', 4: 'PDD', 2: '1688', 5: 'DY', 6: 'WX' }
      return labels[String(value)] || value || '未知'
    },
    priceRange(good) {
      const min = good.min_price ?? good.price_min ?? good.price
      const max = good.max_price ?? good.price_max ?? min
      return min === undefined || min === null ? '价格待定' : `¥${min}~¥${max}`
    },
    switchSelectorTab(t) {
      this.selectorTab = t
      if (t === 'selected') {
        this.selectorPage.total = this.selectedGoods.length
        this.selectorPage.page = 1
      } else this.loadGoods(1)
    },
    loadSelectorGroups() {
      const g = this.groupList.find((x) => String(x.id) === String(this.selectorFilters.group_id))
      this.selectorChildGroups = (g && g.child_groups) || []
      this.selectorFilters.child_group_id = ''
      this.loadGoods(1)
    },
    toggleGood(id) {
      id = String(id)
      if (!id || id === 'undefined' || id === 'null') return
      const i = this.selected.indexOf(id)
      if (i >= 0) {
        this.selected.splice(i, 1)
        this.selectedGoods = this.selectedGoods.filter((g) => String(g.product_id) !== id)
      } else {
        this.selected.push(id)
        const g = this.goods.find((x) => String(x.product_id) === id)
        if (g) this.selectedGoods.push(g)
      }
    },
    togglePageGoods(c) {
      this.displayedGoods.forEach((g) => {
        const id = String(g.product_id)
        if (!id || id === 'undefined' || id === 'null') return
        if (c && !this.selected.includes(id)) {
          this.selected.push(id)
          this.selectedGoods.push(g)
        }
        if (!c) {
          const i = this.selected.indexOf(id)
          if (i >= 0) this.selected.splice(i, 1)
          this.selectedGoods = this.selectedGoods.filter((x) => String(x.product_id) !== id)
        }
      })
    },
    loadGoods(page = 1) {
      return cloudProductList({ page, page_size: this.selectorPage.limit, status: 1, ...this.selectorFilters })
        .then((r) => {
          const d = (r.data && (r.data.data || r.data)) || {}
          this.goods = d.list || d.data || d
          this.selectorPage = { ...this.selectorPage, page, total: Number(d.total || this.goods.length) }
        })
        .catch(() => this.$message.error('商品查询失败'))
    },
    switchMode(m) {
      this.mode = m
      this.invalidate()
    },
    invalidate() {
      this.preview = null
      this.previewKey = ''
      this.skuCache = {}
    },
    async loadGroups() {
      try {
        const r = await cloudProductGroups({ with_count: 0 })
        this.groupList = (r.data && (r.data.data || r.data)) || []
      } catch (e) {
        this.$message.error('请求失败，请稍后重试')
      }
    },
    onGroupChange() {
      const g = this.groupList.find((i) => String(i.id) === String(this.filterValues.group_id))
      this.childGroupList = (g && g.child_groups) || []
      this.filterValues.child_group_id = ''
      this.invalidate()
    },
    optionsFor(k) {
      return k === 'group_id'
        ? this.groupList.map((i) => ({ value: i.id, label: i.name || i.group_name }))
        : k === 'child_group_id'
        ? this.childGroupList.map((i) => ({ value: i.id, label: i.name || i.group_name }))
        : this.statusOptions[k] || []
    },
    buildPayload() {
      const f = this.form
      const ids =
        this.mode === 'goods'
          ? this.selected.map(String)
          : f.productIds
              .split(/[,，\\r\\n]+/)
              .map((v) => v.trim())
              .filter(Boolean)
      const p = {
        product_filter: {
          ...this.filterValues,
          product_ids: ids,
          excluded_product_ids: this.excludedProductIds.map(String),
          add_time_start: this.addTime[0] || '',
          add_time_end: this.addTime[1] || '',
          keyword: f.keyword
        },
        stock_scope: f.stockScope,
        stock_rule: { operation: f.operation }
      }
      const r = p.stock_rule
      // 库存操作
      if (f.operation === 'set') r.new_stock = f.newStock
      if (f.operation === 'formula')
        Object.assign(r, {
          percent: f.percent,
          delta: f.delta,
          subtract: f.subtract
        })
      if (f.operation === 'increase') Object.assign(r, { increase_stock: f.increaseStock, max_stock: f.maxStock })
      if (f.operation === 'decrease') Object.assign(r, { decrease_stock: f.decreaseStock, min_stock: f.minStock })

      // 库存范围选项
      if (f.stockScope === 'range') {
        p.stock_scope_options = {
          min: f.stockScopeMin,
          max: f.stockScopeMax
        }
      }

      // 规格匹配
      const specValue =
        f.stockScope === 'gt_zero'
          ? f.gtZeroSpecField
          : f.stockScope === 'eq_zero'
          ? f.eqZeroSpecField
          : f.stockScope === 'range'
          ? f.rangeSpecField
          : f.allSpecField
      const keywordsValue =
        f.stockScope === 'gt_zero'
          ? f.gtZeroKeywords
          : f.stockScope === 'eq_zero'
          ? f.eqZeroKeywords
          : f.stockScope === 'range'
          ? f.rangeKeywords
          : f.allKeywords
      const spec = String(specValue || 'spec_name:contains').split(':')
      const specEnabled =
        (f.stockScope === 'all' && f.allSkuMode === 'selected_spec') ||
        (f.stockScope === 'gt_zero' && f.gtZeroSkuMode === 'selected_spec') ||
        (f.stockScope === 'eq_zero' && f.eqZeroSkuMode === 'selected_spec') ||
        (f.stockScope === 'range' && f.rangeSkuMode === 'selected_spec')
      p.spec_match = {
        enabled: specEnabled,
        field: spec[0],
        mode: spec[1] || 'contains',
        keywords: specEnabled
          ? String(keywordsValue || '')
              .split(/[,，\r\n]+/)
              .map((v) => v.trim())
              .filter(Boolean)
              .filter((v, i, a) => a.indexOf(v) === i)
          : []
      }

      return p
    },
    payloadKey() {
      return JSON.stringify(this.buildPayload())
    },
    validate() {
      const p = this.buildPayload(),
        r = p.stock_rule
      if (this.mode === 'goods' && !p.product_filter.product_ids.length) return '请选择商品'
      if (
        ((this.form.stockScope === 'all' && this.form.allSkuMode === 'selected_spec') ||
          (this.form.stockScope === 'gt_zero' && this.form.gtZeroSkuMode === 'selected_spec') ||
          (this.form.stockScope === 'eq_zero' && this.form.eqZeroSkuMode === 'selected_spec') ||
          (this.form.stockScope === 'range' && this.form.rangeSkuMode === 'selected_spec')) &&
        !p.spec_match.keywords.length
      )
        return '请填写 SKU 规格名称关键字'
      if (
        ((this.form.stockScope === 'all' && this.form.allSkuMode === 'selected_spec') ||
          (this.form.stockScope === 'gt_zero' && this.form.gtZeroSkuMode === 'selected_spec') ||
          (this.form.stockScope === 'eq_zero' && this.form.eqZeroSkuMode === 'selected_spec') ||
          (this.form.stockScope === 'range' && this.form.rangeSkuMode === 'selected_spec')) &&
        p.spec_match.keywords.length > 100
      )
        return 'SKU关键字最多输入100个'

      // 库存范围验证
      if (this.form.stockScope === 'range') {
        if (this.form.stockScopeMin === '' || this.form.stockScopeMax === '') return '请输入库存区间'
        if (Number(this.form.stockScopeMin) > Number(this.form.stockScopeMax)) return '库存区间最小值不能大于最大值'
      }

      // 库存操作验证
      const integer = /^\d+$/
      if (r.operation === 'set') {
        if (!integer.test(String(r.new_stock))) return '请输入合法库存数量'
        if (Number(r.new_stock) < 0) return '库存不能为负数'
      }
      if (r.operation === 'formula') {
        if (!Number.isFinite(Number(r.percent))) return '百分比必须为数字'
        if (!Number.isFinite(Number(r.delta))) return '增减量必须为数字'
      }
      if (r.operation === 'increase') {
        if (!integer.test(String(r.increase_stock))) return '请输入合法的新增库存'
        if (Number(r.increase_stock) < 0) return '新增库存不能为负数'
        if (r.max_stock !== '' && !integer.test(String(r.max_stock))) return '请输入合法的最高库存'
      }
      if (r.operation === 'decrease') {
        if (!integer.test(String(r.decrease_stock))) return '请输入合法的减少库存'
        if (Number(r.decrease_stock) < 0) return '减少库存不能为负数'
        if (r.min_stock !== '' && !integer.test(String(r.min_stock))) return '请输入合法的最低库存'
      }

      return ''
    },
    async previewBatch() {
      const e = this.validate()
      if (e) return this.$message.warning(e)
      this.previewLoading = true
      try {
        const r = await previewCloudSkuStockBatch({
          ...this.buildPayload(),
          page: this.previewPage.page,
          limit: this.previewPage.limit
        })
        const body = r && r.data && r.data.code !== undefined ? r.data : r
        if (body && body.code && body.code !== 200) throw Error(body.msg || body.message || '预览失败')
        this.preview = (r.data && (r.data.data || r.data)) || {}
        this.previewGoods = this.preview.list || this.preview.products || this.preview.items || []
        this.previewPage.total = Number(
          this.preview.product_count || this.preview.total || this.previewGoods.length || 0
        )
        this.previewKey = this.payloadKey()
      } catch (e) {
        this.invalidate()
        this.$message.error(
          (e.response && e.response.data && (e.response.data.msg || e.response.data.message)) ||
            e.message ||
            '请求失败，请稍后重试'
        )
      } finally {
        this.previewLoading = false
      }
    },
    async previewBatchPage(page) {
      this.previewPage.page = page
      await this.previewBatch()
    },
    async createBatch() {
      if (!this.canCreate) return this.$message.warning('请先预览当前修改规则')
      this.submitting = true
      try {
        const r = await createCloudSkuStockBatch(this.buildPayload())
        const body = r && r.data && r.data.code !== undefined ? r.data : r
        if (body && body.code && body.code !== 200) throw Error(body.msg || body.message || '任务创建失败')
        this.$message.success('任务已创建')
        this.$emit('back')
      } catch (e) {
        this.$message.error(
          (e.response && e.response.data && (e.response.data.msg || e.response.data.message)) ||
            e.message ||
            '请求失败，请稍后重试'
        )
      } finally {
        this.submitting = false
      }
    },
    toggleExclude(g) {
      const id = String(g.product_id),
        i = this.excludedProductIds.indexOf(id)
      if (!id || id === 'undefined' || id === 'null') return
      i < 0 ? this.excludedProductIds.push(id) : this.excludedProductIds.splice(i, 1)
      this.invalidate()
    },
    reset() {
      Object.assign(this.filterValues, {
        group_id: '',
        child_group_id: '',
        source_product_id: '',
        sku_status: '',
        sku_mark_status: '',
        ai_title_status: '',
        source_web: ''
      })
      this.addTime = []
      Object.assign(this.form, {
        productIds: '',
        keyword: '',
        stockScope: 'all',
        specField: 'spec_name:contains',
        specMode: 'contains',
        keywords: '',
        allSpecField: 'spec_name:contains',
        allKeywords: '',
        lowestSpecField: 'spec_name:contains',
        lowestKeywords: '',
        highestSpecField: 'spec_name:contains',
        highestKeywords: '',
        allSkuMode: 'all_spec',
        lowestSpecMode: 'all_spec',
        highestSpecMode: 'all_spec',
        lowestSkuMode: 'first',
        highestSkuMode: 'first',
        operation: 'set',
        newStock: '',
        increaseStock: '0',
        decreaseStock: '0',
        rate: '100',
        add: '0',
        subtract: '0',
        direction: 'add',
        factorDirection: 'multiply',
        amount: '0',
        factor: '1',
        decimalPart: '',
        min: '',
        max: '',
        matchRules: [{ match: '', value: '' }],
        precision: 2,
        rounding: 'none',
        finalRate: '100',
        tailAmount: '',
        equalPriceMode: 'all',
        equalPriceAction: 'skip',
        randomMode: 'add',
        guardMinPercentEnabled: false,
        guardMinPriceEnabled: false,
        guardMaxPriceEnabled: false,
        guardMinPercent: '',
        guardMinPrice: '',
        guardMaxPrice: ''
      })
      this.selected = []
      this.invalidate()
    },
    async openSelector() {
      this.selecting = true
      this.selectorTab = 'all'
      await this.loadGroups()
      this.loadSelectorGroups()
      await this.loadGoods(1)
    }
  }
}
</script>
<style scoped>
.bm-title__repeat-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.bm-title__repeat-row .bm-title__select {
  min-width: 160;
}

@media (max-width: 768px) {
  .bm-title__repeat-row {
    align-items: flex-start;
    flex-direction: column;
  }
}

.bm-title {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  min-height: calc(100vh - 56px);
  overflow-x: hidden;
  background: #f5f6f8;
  color: #1a1a2e;
  font-family: 'Noto Sans SC', sans-serif;
}

.bm-title__preview tr:nth-child(even) {
  background: #fcfcfd;
}

.bm-title__preview tr:hover {
  background: #f0f7ff;
}

.bm-title__preview tr.is-excluded {
  background: #e5e5e5;
  color: #777;
}

.bm-title button,
.bm-title input,
.bm-title select,
.bm-title textarea {
  font: inherit;
}

.bm-title button {
  cursor: pointer;
}

.bm-title__head {
  background: #fff;
  border-bottom: 1px solid #e0e0ec;
  padding: 10px 20px 0;
}

.bm-title__crumb {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #999;
}

.bm-title__crumb button {
  height: 26px;
  padding: 0 10px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  color: #666;
}

.bm-title__crumb a {
  margin-left: auto;
  color: #1677ff;
}

.bm-title h1 {
  margin: 12px 0 8px;
  font: 600 18px 'Noto Serif SC', serif;
}

.bm-title__head nav {
  display: flex;
  gap: 22px;
}

.bm-title__head nav button {
  padding: 9px 6px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: #fff;
  color: #666;
  font-size: 13px;
}

.bm-title__head nav button.active {
  border-bottom-color: #c8443c;
  color: #c8443c;
  font-weight: 600;
}

.bm-title__body {
  padding: 14px 20px 82px;
}

.bm-title__filter {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px 14px;
  padding: 14px 16px 10px;
  border: 2px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
}

.bm-title__field label {
  display: block;
  margin-bottom: 4px;
  color: #666;
  font-size: 10px;
}

.bm-title__field input,
.bm-title__field select,
.bm-title__range input,
.bm-title__method-content input,
.bm-title__method-content select,
.bm-title__method-content textarea,
.bm-title__options select,
.bm-title__select-filter input {
  box-sizing: border-box;
  width: 100%;
  height: 28px;
  padding: 4px 8px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  font-size: 11px;
}

.bm-title__range {
  display: flex;
  align-items: center;
  gap: 5px;
}

.bm-title__range span {
  color: #999;
}

.bm-title__filter footer {
  grid-column: 1/-1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding-top: 9px;
  border-top: 1px solid #f0f0f0;
  font-size: 12px;
}

.bm-title__filter footer span {
  margin-right: auto;
  color: #999;
}

.bm-title__filter b {
  color: #1677ff;
}

.bm-title__filter button,
.bm-title__picked button,
.bm-title__small-modal footer button,
.bm-title__select-modal footer button {
  height: 28px;
  padding: 0 13px;
  border: 0;
  border-radius: 4px;
  background: #c8443c;
  color: #fff;
  font-size: 12px;
}

.bm-title__filter .plain,
.bm-title__small-modal .plain {
  border: 1px solid #e0e0ec;
  background: #fff;
  color: #666;
}

.bm-title__picked,
.bm-title__fail,
.bm-title__options {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 14px;
  padding: 10px 14px;
  border: 1px solid #e0e0ec;
  border-radius: 6px;
  background: #fff;
  color: #666;
  font-size: 12px;
}

.bm-title__picked button {
  background: #1677ff;
}

.bm-title__picked span {
  color: #1677ff;
}

.bm-title__fail {
  border-color: #ffccd2;
  background: #fff5f5;
  color: #1a1a2e;
}

.bm-title__methods {
  overflow: hidden;
  margin-top: 14px;
  border: 2px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
}

.bm-title__methods > header {
  padding: 10px 14px;
  border-bottom: 1px solid #e0e0ec;
  background: #f5f0e8;
  font-size: 12px;
  font-weight: 600;
}

.bm-title__methods > header p {
  display: inline-block;
  width: 3px;
  height: 14px;
  margin-right: 7px;
  border-radius: 2px;
  background: #c8443c;
  vertical-align: middle;
}

.bm-title__methods article {
  padding: 12px 14px;
  border-bottom: 1px solid #e0e0ec;
  font-size: 12px;
}

.bm-title__methods article:last-child {
  border-bottom: 0;
}

.bm-title__method-name {
  font-weight: 500;
}

.bm-title__method-content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin: 10px 0 0 22px;
  color: #666;
}

.bm-title__method-content input {
  width: 190px;
}

.bm-title__method-content input.long {
  width: 360px;
}

.bm-title__method-content textarea {
  width: 360px;
  height: 62px;
  resize: vertical;
}

.bm-title__method-content select {
  width: 145px;
}

.bm-title__method-content small {
  color: #999;
  font-size: 10px;
}

.bm-title__method-content .warning {
  color: #c8443c;
}

.bm-title__replace {
  display: flex;
  align-items: center;
  gap: 8px;
}

.bm-title__replace button {
  height: 28px;
  padding: 0 10px;
  border: 1px solid #91caff;
  border-radius: 4px;
  background: #e6f4ff;
  color: #1677ff;
  font-size: 11px;
}

.bm-title__options {
  background: #f5f0e8;
}

.bm-title__options span {
  margin-left: auto;
}

.bm-title__options select {
  width: 150px;
}

.bm-title__preview {
  overflow: hidden;
  margin-top: 14px;
  border: 2px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
}

.bm-title__preview header {
  padding: 10px 14px;
  border-bottom: 1px solid #e0e0ec;
  font-size: 12px;
}

.bm-title__preview header b {
  color: #1677ff;
}

.bm-title__preview header button {
  float: right;
  border: 0;
  background: none;
  color: #c8443c;
}

.bm-title__preview table {
  width: 100%;
  border-collapse: collapse;
}

.bm-title__preview th {
  padding: 8px 12px;
  background: #f5f0e8;
  color: #666;
  font-size: 11px;
  font-weight: 500;
  text-align: left;
}

.bm-title__preview td {
  padding: 10px 12px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 11px;
}

.bm-title__head nav .mode-range {
  color: #1677ff;
}

.bm-title__head nav .mode-goods {
  color: #722ed1;
}

.bm-title__head nav .mode-range.active {
  border-bottom-color: #1677ff;
  background: #f0f7ff;
}

.bm-title__head nav .mode-goods.active {
  border-bottom-color: #722ed1;
  background: #f9f0ff;
  color: #722ed1;
}

.bm-title__preview .title-col,
.bm-title__preview .title-cell,
.bm-title__preview .action-cell {
  text-align: center;
  vertical-align: middle;
}

.bm-title__preview td:first-child {
  display: flex;
  align-items: center;
  gap: 8px;
}

.bm-title__preview p {
  margin: 3px 0 0;
}

.bm-title__preview small {
  line-height: 16px;
  color: #999;
}

.bm-title__preview .preview-meta {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 10px;
  margin-top: 4px;
  white-space: nowrap;
  line-height: 16px;
}

.bm-title__preview .preview-meta small {
  display: inline;
  margin: 0;
}

.bm-title__sku-list .sku-error {
  color: #f56c6c;
}

.bm-title__preview .bm-title__sku-list .sku-matched-row {
  background: #f0f9eb;
}

.bm-title__preview .bm-title__sku-list .sku-unmatched-row {
  background: #f5f5f5;
  color: #909399;
}

.bm-title__preview .bm-title__sku-list .sku-failed-row {
  background: #fef0f0;
}

.bm-title__preview .bm-title__sku-list .sku-matched-row:hover {
  background: #e1f3d8;
}

.bm-title__preview .bm-title__sku-list .sku-unmatched-row:hover {
  background: #ebebeb;
}

.bm-title__preview .bm-title__sku-list .sku-failed-row:hover {
  background: #fde2e2;
}

.bm-title__preview textarea {
  width: 100%;
  min-height: 38px;
  box-sizing: border-box;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  font-size: 11px;
}

.bm-title__preview .title-cell textarea {
  min-width: 300px;
  padding: 5px;
  line-height: 1;
  background: #fafcff;
  resize: vertical;
}

.bm-title__preview td button {
  height: 24px;
  border: 1px solid #91caff;
  border-radius: 3px;
  background: #e6f4ff;
  color: #1677ff;
  font-size: 10px;
}

.bm-title__field {
  min-width: 0;
}

.bm-title__preview .action-cell {
  min-width: 110px;
  white-space: nowrap;
}

.bm-title__preview .action-cell button {
  min-width: 82px;
  height: 30px;
  padding: 0 12px;
  border-color: #91caff;
  border-radius: 5px;
  background: #e6f4ff;
  color: #1677ff;
  font-size: 12px;
  line-height: 28px;
  transition: 0.2s;
}

.bm-title__preview .action-cell button:hover,
.bm-title__preview .action-cell button:focus {
  border-color: #409eff;
  background: #bae0ff;
  color: #0958d9;
}

.bm-title__preview .action-cell button:active {
  transform: translateY(1px);
}

.bm-title__preview .action-cell button.restore {
  border-color: #ffd591;
  background: #fff7e6;
  color: #d46b08;
}

.bm-title__preview .action-cell button.restore:hover,
.bm-title__preview .action-cell button.restore:focus {
  border-color: #ffa940;
  background: #ffe7ba;
  color: #ad4e00;
}

.bm-title__preview td button:hover {
  background: #bae0ff;
}

.bm-title__preview td button.restore {
  border-color: #ffd591;
  background: #fff7e6;
  color: #d46b08;
}

.bm-title__image {
  display: inline-flex;
  position: relative;
  z-index: 1;
  width: 46px;
  height: 46px;
  align-items: center;
  justify-content: center;
  border: 1px solid #ffccd2;
  border-radius: 4px;
  background: #fff5f5;
  object-fit: cover;
  font-size: 16px;
  cursor: pointer;
}

.bm-title__pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 10px 14px;
  border-top: 1px solid #f0f0f0;
  color: #666;
  font-size: 12px;
}

.bm-title__pagination button {
  padding: 4px 10px;
  border: 1px solid #d9e2f0;
  border-radius: 4px;
  background: #fff;
  color: #1677ff;
}

.bm-title__pagination button:disabled {
  color: #bbb;
  cursor: not-allowed;
}

.bm-title__pagination select {
  height: 26px;
  border: 1px solid #d9e2f0;
  border-radius: 4px;
}

::v-deep(.bm-title__image .el-image__inner) {
  border-radius: 4px;
  cursor: pointer;
}

.bm-title__bottom {
  position: fixed;
  left: var(--merchant-sidebar-width, 210px);
  right: 0;
  z-index: 20;
  bottom: 0;
  display: flex;
  width: auto;
  max-width: none;
  min-width: 0;
  box-sizing: border-box;
  overflow-x: hidden;
  flex-wrap: nowrap;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
  border-top: 1px solid #e0e0ec;
  background: #fff;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
  font-size: 12px;
}

.bm-title__bottom button {
  min-width: 0;
  flex: 0 1 auto;
  height: 30px;
  padding: 0 14px;
  border: 0;
  border-radius: 4px;
  color: #fff;
}

.bm-title__bottom .preview {
  background: #1677ff;
}

.bm-title__bottom .start {
  margin-left: auto;
  margin-right: 50px;
  padding: 0 28px;
  background: #52c41a;
}

.bm-title__bottom .time {
  background: #fff;
  color: #666;
  border: 1px solid #e0e0ec;
}

.bm-title__mask {
  position: fixed;
  z-index: 3000;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(3px);
}

.bm-title__select-modal,
.bm-title__small-modal {
  width: min(1180px, 96vw);
  min-width: 900px;
  overflow: hidden;
  border: 1px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
}

.bm-title__small-modal {
  width: min(400px, 100%);
  min-width: 0;
}

.bm-title__select-modal > header,
.bm-title__small-modal > header {
  display: flex;
  justify-content: space-between;
  padding: 12px 18px;
  border-bottom: 1px solid #e0e0ec;
  background: #fafafa;
  font-size: 14px;
}

.bm-title__select-modal > header button,
.bm-title__small-modal > header button {
  width: 24px;
  height: 24px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  color: #666;
  font-size: 18px;
}

.bm-title__select-modal nav {
  display: flex;
  padding: 0 18px;
  border-bottom: 1px solid #e0e0ec;
}

.bm-title__select-modal nav button {
  padding: 10px 14px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: #fff;
  color: #666;
  font-size: 12px;
}

.bm-title__select-modal nav button.active {
  border-bottom-color: #1677ff;
  color: #1677ff;
}

.bm-title__select-filter {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px 18px;
  background: #fafafa;
}

.bm-title__selector-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 18px;
  background: #fafafa;
}

.bm-title__selector-toolbar .bm-title__select-filter {
  flex: 1;
  padding: 0;
  background: transparent;
}

.bm-title__page-size {
  width: 96px;
}

.bm-title__select-all {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  margin-left: auto;
  white-space: nowrap;
  gap: 6px;
  font-size: 12px;
}

.bm-title__select-filter .bm-title__group-select {
  width: 108px;
}

.bm-title__select-filter .bm-title__group-select .el-input,
.bm-title__select-filter .bm-title__group-select .el-input__inner {
  width: 108px;
}

.bm-title__select-filter .bm-title__group-select .el-input,
.bm-title__select-filter .bm-title__group-select .el-input__inner,
.bm-title__selector-pagination .bm-title__page-size .el-input,
.bm-title__selector-pagination .bm-title__page-size .el-input__inner {
  height: 28px;
  line-height: 28px;
}

::v-deep(.el-input__inner),
::v-deep(.el-input__icon) {
  height: 28px;
  line-height: 28px;
}

.bm-title__select-filter input {
  width: 150px;
  height: 28px;
}

.bm-title__selector-pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 0;
  color: #666;
  font-size: 12px;
}

.bm-title__selector-pagination button {
  padding: 3px 8px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  color: #606266;
}

.bm-title__selector-pagination button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.bm-title__select-filter button {
  height: 28px;
  padding: 0 12px;
  border: 0;
  border-radius: 4px;
  background: #1677ff;
  color: #fff;
  font-size: 11px;
}

.bm-title__select-modal main {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 10px;
  max-height: 350px;
  padding: 14px 18px;
  overflow: auto;
}

.bm-title__select-modal main button {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px;
  border: 2px solid #e0e0ec;
  border-radius: 6px;
  background: #fff;
  color: #1a1a2e;
  text-align: left;
  min-height: 150px;
}

.bm-title__select-modal main button.selected {
  border-color: #1677ff;
  background: #e6f4ff;
}

.bm-title__select-modal main b {
  height: 48px;
  background: #fff5f5;
  font-size: 27px;
  text-align: center;
}

.bm-title__select-modal main img {
  width: 100%;
  height: 159px;
  object-fit: contain;
  background: #fff5f5;
}

.bm-title__select-modal main span {
  overflow: hidden;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bm-title__select-modal main small {
  color: #999;
  font-size: 10px;
}

.bm-title__select-modal footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  align-items: center;
  padding: 10px 18px;
  border-top: 1px solid #e0e0ec;
  font-size: 12px;
}

.bm-title__select-modal footer > span {
  margin-right: auto;
}

.bm-title__select-modal footer button {
  background: #1677ff;
}

.bm-title__small-modal main {
  padding: 24px 20px;
  font-size: 13px;
}

.bm-title__small-modal main label {
  display: flex;
  align-items: center;
  gap: 10px;
}

.bm-title__small-modal main input {
  height: 28px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
}

.bm-title__small-modal footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 18px;
  border-top: 1px solid #e0e0ec;
}

.bm-title__small-modal .success-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.bm-title__small-modal .success-message b {
  display: flex;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #f6ffed;
  color: #52c41a;
  font-size: 28px;
}

.bm-title__small-modal .success-message p {
  margin: 12px 0 5px;
}

.bm-title__small-modal .success-message small {
  color: #999;
}

@media (max-width: 960px) {
  .bm-title__filter {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .bm-title__options span {
    margin-left: 0;
  }

  .bm-title__select-modal {
    min-width: 0;
  }

  .bm-title__select-modal main {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .bm-title__selector-toolbar {
    flex-wrap: wrap;
  }
}

@media (max-width: 720px) {
  .bm-title__filter {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .bm-title__select-modal main {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .bm-title__bottom .start {
    margin-left: 0;
  }
}

@media (max-width: 520px) {
  .bm-title__head,
  .bm-title__body {
    padding-right: 12px;
    padding-left: 12px;
  }

  .bm-title__filter {
    grid-template-columns: 1fr;
  }

  .bm-title__method-content input,
  .bm-title__method-content input.long,
  .bm-title__method-content textarea {
    width: 100%;
  }

  .bm-title__select-modal main {
    grid-template-columns: repeat(2, 1fr);
  }

  .bm-title__bottom {
    left: 0;
    gap: 6px;
    padding: 8px 12px;
  }

  .bm-title__bottom .start {
    padding: 0 12px;
  }

  .bm-title__bottom .preview {
    display: none;
  }
}

.bm-title__method-name {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #1a1a2e;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  cursor: pointer;
}

.bm-title__method-name input,
.bm-title__method-content input[type='checkbox'],
.bm-title__method-content input[type='radio'] {
  width: 14px;
  height: 14px;
  min-width: 14px;
  margin: 0;
  padding: 0;
  accent-color: #1677ff;
  cursor: pointer;
}

.bm-title__method-content {
  align-items: center;
  margin-top: 10px;
  padding-left: 22px;
  line-height: 28px;
}

.bm-title__method-content > label {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
  cursor: pointer;
}

.bm-title__method-content > span {
  flex-shrink: 0;
  color: #666;
  font-size: 12px;
}

.bm-title__method-content .bm-title__count-input,
.bm-title__method-content .bm-title__count-textarea {
  position: relative;
  line-height: normal;
}

.bm-title__method-content .bm-title__count-input input {
  width: 360px;
}

.bm-title__method-content .bm-title__count-input small,
.bm-title__method-content .bm-title__count-textarea small {
  position: absolute;
  right: 8px;
  bottom: 5px;
  color: #999;
  font: 10px 'JetBrains Mono', monospace;
}

.bm-title__method-content .bm-title__count-textarea textarea {
  width: 360px;
  padding-bottom: 18px;
}

.bm-title__method-content .bm-title__replace {
  width: 100%;
  gap: 8px;
}

.bm-title__method-content .bm-title__replace input {
  width: 160px;
}

.bm-title__replace .danger {
  border-color: #ffccd2;
  background: #fff5f5;
  color: #c8443c;
}

.bm-title__method-content .bm-title__inline {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.bm-title__method-content .bm-title__inline input:not([type='checkbox']):not([type='radio']) {
  width: 200px;
}

.bm-title__method-content select:disabled {
  background: #f5f5f5;
  color: #999;
}

.bm-title__method-content > .warning {
  display: block;
  width: 100%;
  line-height: 16px;
}

.bm-title__methods article {
  padding: 14px 14px 13px;
}

::v-deep(.bm-title__methods .el-checkbox__inner) {
  width: 14px;
  height: 14px;
  border-color: #d9c98d;
  border-radius: 3px;
}

::v-deep(.bm-title__methods .el-checkbox__inner:hover),
::v-deep(.bm-title__methods .el-checkbox__input.is-focus .el-checkbox__inner) {
  border-color: #d4a946;
}

::v-deep(.bm-title__methods .el-checkbox__input.is-checked .el-checkbox__inner),
::v-deep(.bm-title__methods .el-checkbox__input.is-indeterminate .el-checkbox__inner) {
  border-color: #d4a946;
  background: #d4a946;
}

::v-deep(.bm-title__methods .el-checkbox__label) {
  color: #1a1a2e;
  font-size: 12px;
}

::v-deep(.bm-title__methods .el-checkbox__input.is-checked + .el-checkbox__label) {
  color: #1a1a2e;
}

.bm-title__select {
  width: 235px;
  line-height: normal;
}

.bm-title__filter-select {
  display: block;
  width: 100%;
}

.bm-title__date-range {
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  gap: 5px;
}

.bm-title__date-input {
  flex: 1 1 0;
  min-width: 0;
  box-sizing: border-box;
  width: 0;
  height: 28px;
  padding: 4px 8px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  color: #666;
  font-size: 11px;
}

.bm-title__date-separator {
  flex: 0 0 12px;
  color: #999;
  text-align: center;
}

.bm-title__store-select {
  width: 120px;
}

.bm-title__stores,
.bm-title__filter footer > div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.bm-title__filter .add-store {
  background: #722ed1;
}

.bm-title__filter .add-store:hover {
  background: #531dab;
}

::v-deep(.bm-title__select .el-input__inner),
::v-deep(.bm-title__filter-select .el-input__inner),
::v-deep(.bm-title__store-select .el-input__inner) {
  height: 28px;
  padding: 0 28px 0 8px;
  border-color: #e0e0ec;
  border-radius: 4px;
  color: #1a1a2e;
  font-size: 12px;
  line-height: 28px;
  text-align: left;
}

::v-deep(.bm-title__select .el-input__suffix),
::v-deep(.bm-title__filter-select .el-input__suffix),
::v-deep(.bm-title__store-select .el-input__suffix) {
  right: 7px;
}

::v-deep(.bm-title__select .el-input__icon),
::v-deep(.bm-title__filter-select .el-input__icon),
::v-deep(.bm-title__store-select .el-input__icon) {
  color: #999;
  font-size: 14px;
  line-height: 28px;
}

::v-deep(.bm-title__select .el-input__inner:focus),
::v-deep(.bm-title__filter-select .el-input__inner:focus),
::v-deep(.bm-title__store-select .el-input__inner:focus) {
  border-color: #d4a946;
}

.bm-title__filter .more-search {
  padding: 0 2px;
  background: transparent;
  color: #1677ff;
}

.bm-title__more-modal {
  width: min(540px, 100%);
  overflow: hidden;
  border: 1px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
}

.bm-title__more-modal > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 18px;
  border-bottom: 1px solid #e0e0ec;
  background: #fafafa;
  font-size: 14px;
}

.bm-title__more-modal > header button {
  width: 24px;
  height: 24px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  color: #666;
  font-size: 18px;
}

.bm-title__more-modal main {
  padding: 16px 18px;
}

.bm-title__more-modal .el-checkbox-group {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.bm-title__more-modal footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 18px;
  border-top: 1px solid #e0e0ec;
}

.bm-title__more-modal footer button {
  height: 28px;
  padding: 0 13px;
  border: 0;
  border-radius: 4px;
  background: #1677ff;
  color: #fff;
  font-size: 12px;
}

.bm-title__more-modal footer .plain {
  border: 1px solid #e0e0ec;
  background: #fff;
  color: #666;
}

::v-deep(.bm-title__more-modal .el-checkbox__inner) {
  width: 14px;
  height: 14px;
  border-color: #d9c98d;
  border-radius: 3px;
}

::v-deep(.bm-title__more-modal .el-checkbox__input.is-checked .el-checkbox__inner) {
  border-color: #d4a946;
  background: #d4a946;
}

::v-deep(.bm-title__more-modal .el-checkbox__label) {
  color: #1a1a2e;
  font-size: 12px;
}

.bm-title__filter > footer {
  justify-content: space-between;
}

/* 价格范围首行同行，重复价格处理固定在第二行 */
.sku-scope-children-price {
  flex-wrap: wrap;
}

.sku-scope-children-price .sku-scope-mode,
.sku-scope-children-price .sku-scope-config {
  width: auto;
  flex: 0 0 auto;
}

.sku-scope-children-price .sku-scope-config {
  max-width: none;
}

.sku-scope-children-price .sku-scope-equal-price-row {
  flex: 0 0 100%;
  width: 100%;
}
</style>
<style>
.el-popper.bm-title__select-popper {
  z-index: 4000 !important;
}

.bm-title__methods > .el-radio-group,
.bm-title__methods article > .bm-title__method-content:first-child {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}

.bm-title__methods article > .bm-title__method-content {
  width: calc(100% - 22px);
}

.sku-methods {
  padding: 0;
  margin-bottom: 18px;
}

.sku-methods > header,
.price-methods > header {
  margin: 0;
  padding: 12px 16px;
  background: #f8f5ef;
  border-bottom: 1px solid #dfe3eb;
}

.sku-scope-help {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin-left: 6px;
  border: 1px solid #8c98a8;
  border-radius: 50%;
  color: #6b7785;
  font-size: 11px;
  cursor: help;
}

.sku-scope-options {
  display: block;
  width: 100%;
  padding: 12px 16px;
}

.sku-scope-row-main {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-bottom: 12px;
}

.sku-scope-row-main .el-checkbox {
  margin-right: 0;
}

.stock-range-inline {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-left: 12px;
}

.stock-range-inline .el-input-number {
  width: 120px;
}

.stock-range-inline .el-input-number >>> .el-input__inner {
  padding-left: 8px;
  padding-right: 32px;
}

.stock-range-inline span {
  font-size: 14px;
  color: #606266;
}

.sku-scope-row-detail {
  display: flex;
  align-items: center;
  gap: 16px;
  padding-left: 0;
}

.sku-scope-row-detail .sku-scope-mode {
  display: flex;
  align-items: center;
  gap: 24px;
  flex-shrink: 0;
}

.sku-scope-row-detail .sku-scope-config {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
}

.sku-scope-row-detail .sku-scope-config .bm-title__select .el-input {
  width: 235px;
  flex: 0 0 235px;
}

.sku-scope-row-detail .sku-scope-config .el-input {
  width: 300px;
  flex: 0 0 300px;
}

.sku-scope-row-detail .sku-keyword-count {
  font-size: 12px;
  color: #909399;
  white-space: nowrap;
  flex: 0 0 auto;
}

.sku-scope-option {
  display: flex;
  align-items: center;
  min-height: 32px;
  background: #fff;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.sku-scope-option:hover,
.sku-scope-option.active {
  /* background: #fffdf7; */
}

.sku-scope-option .el-radio {
  width: 100%;
  margin: 0;
}

.sku-scope-option > .el-radio {
  width: auto;
  flex: 0 0 auto;
}

.sku-scope-option .el-radio__label {
  color: #172b4d;
  font-weight: 600;
  white-space: normal;
  line-height: 20px;
}

.sku-scope-config sku-scope-all-config {
  margin: 0;
  padding: 12px 16px 14px 40px;
  border-bottom: 1px solid #e1e4eb;
  border-radius: 0;
  background: #fff;
}

.sku-scope-mode {
  display: inline-flex !important;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin: 0;
}

.sku-scope-mode .el-radio {
  width: auto;
  margin: 0;
}

.sku-scope-mode .el-checkbox {
  margin: 0;
}

.sku-scope-block {
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding: 12px 16px;
  border-bottom: 1px solid #e1e4eb;
  background: #fff;
}

.sku-scope-block > .el-radio {
  display: block;
  margin: 0;
  line-height: 24px;
}

.sku-scope-children {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  width: calc(100% - 28px);
  min-width: 0;
  box-sizing: border-box;
  margin: 6px 0 0 28px;
  padding-left: 14px;
  overflow-x: auto;
  overflow-y: hidden;
}

.sku-scope-children {
  gap: 8px 16px;
}

.sku-scope-children .sku-scope-mode,
.sku-scope-children .sku-scope-config {
  flex: 0 0 auto;
  width: auto;
  white-space: nowrap;
}

.sku-scope-children .el-checkbox {
  margin: 0;
  color: #606b78;
}

.sku-scope-equal-price-label {
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  color: #1a1a2e;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
}

.sku-scope-equal-price-row {
  display: flex;
  align-items: center;
  gap: 8px 16px;
  flex: 0 0 auto;
  white-space: nowrap;
}

.sku-scope-children-stacked {
  flex-direction: column;
  align-items: flex-start;
}

.sku-scope-children-stacked .sku-scope-config,
.sku-scope-children-stacked .sku-scope-equal-price-row {
  width: 100%;
}

.sku-scope-children-price {
  flex-wrap: wrap;
  overflow-x: auto;
}

.sku-scope-children-price .sku-scope-equal-price-row {
  flex: 0 0 100%;
}

/* 价格范围首行控件同行，第二行仅显示重复价格处理 */
.sku-scope-children-price .sku-scope-mode {
  width: auto;
  flex: 0 0 auto;
  flex-wrap: nowrap;
}

.sku-scope-children-price .sku-scope-config {
  width: auto;
  flex: 0 0 auto;
  max-width: none;
}

.sku-scope-children-price .sku-scope-equal-price-row {
  width: 100%;
  flex: 0 0 100%;
}

.sku-scope-children .sku-scope-config sku-scope-all-config {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 8px 0 0;
  border: 0;
}

.sku-scope-config sku-scope-all-config-label {
  flex: 0 0 auto;
  color: #606b78;
  line-height: 32px;
}

.sku-scope-all-config {
  display: inline-flex !important;
  align-items: center;
  vertical-align: middle;
  padding: 0 !important;
  border: 0 !important;
}

.sku-scope-children .sku-scope-mode {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}

.sku-scope-children .sku-scope-config {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 8px;
  overflow: visible;
}

.sku-scope-children .sku-scope-config sku-scope-all-config .el-select {
  width: 210px;
}

.sku-scope-children .sku-scope-config sku-scope-all-config .el-input {
  width: 300px;
}

.sku-scope-extra {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 8px 16px 10px 40px;
  border-bottom: 1px solid #e1e4eb;
  color: #606b78;
  font-size: 12px;
}

.sku-keyword-count {
  color: #909399;
  font-size: 12px;
  white-space: nowrap;
}

/* SKU 子项与配置按内容收缩，避免被 width:100% 强制撑满 */
.sku-scope-children {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
}

.sku-scope-children .sku-scope-mode {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  width: auto;
  max-width: max-content;
  flex-wrap: nowrap;
  white-space: nowrap;
}

.sku-scope-children .sku-scope-config {
  display: flex;
  align-items: center;
  flex: 0 1 auto;
  width: auto;
  max-width: 100%;
  min-width: 0;
  flex-wrap: nowrap;
  gap: 8px;
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
}

.sku-scope-children .sku-scope-config > .el-select {
  flex: 0 0 235px;
  width: 235px;
}

.sku-scope-children .sku-scope-config > .el-input {
  flex: 0 0 350px;
  width: 350px;
  min-width: 0;
  max-width: 350px;
}

.sku-scope-children .sku-scope-config .sku-keyword-count {
  flex: 0 0 auto;
  white-space: nowrap;
}

::v-deep(.sku-scope-config .el-select .el-input__suffix) {
  right: 6px;
  display: flex;
  align-items: center;
}

::v-deep(.sku-scope-config .el-select .el-input__icon) {
  display: inline-block;
  width: 25px;
  color: #999;
  font-size: 14px;
  line-height: 28px;
}

::v-deep(.el-select.bm-title__select .el-input__inner) {
  width: 235px;
  box-sizing: border-box;
}

/* 五个 SKU 分组统一：配置控件固定在同一行 */
.sku-scope-children .sku-scope-mode {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 16px;
  width: 100%;
}

.sku-scope-children .sku-scope-config {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 8px;
  width: 100%;
  min-width: 0;
  overflow-x: auto;
}

.sku-scope-children .sku-scope-config > .el-select {
  flex: 0 0 235px;
  width: 235px;
}

.sku-scope-children .sku-scope-config > .el-input {
  flex: 0 0 350px;
  width: 350px;
  min-width: 0;
  max-width: 350px;
}

.sku-scope-children .sku-scope-config .sku-keyword-count {
  flex: 0 0 auto;
  white-space: nowrap;
}

.bm-title__methods:not(.sku-methods) article > .bm-title__method-content:first-child .el-radio-group {
  display: block;
  width: 100%;
}

.bm-title__methods:not(.sku-methods) article > .bm-title__method-content:first-child .el-radio {
  display: block;
  width: 100%;
  margin: 0 0 10px;
}

.bm-title__filter > footer {
  justify-content: flex-start;
}

.price-methods article {
  display: block;
  padding: 0;
}

.price-method {
  position: relative;
  display: flex;
  align-items: flex-start;
  padding: 12px 16px;
  border: 0;
  border-bottom: 1px solid #e1e4eb;
  border-radius: 0;
  background: #fff;
  transition: background 0.2s;
}

.price-method:hover {
  background: #fafbfd;
}

.price-method.active {
  /* background: #fffdf7; */
  box-shadow: none;
}

.price-method.disabled {
  cursor: not-allowed;
  opacity: 0.52;
}

.price-method-title {
  flex: 0 0 150px;
  min-height: 32px;
  display: flex;
  align-items: center;
  padding: 0 12px 0 0;
}

.price-method-title .el-radio {
  display: block;
  width: 100%;
  margin: 0;
  line-height: 24px;
}

.price-method-title .el-radio__label {
  color: #172b4d;
  font-weight: 600;
}

.price-method-fields {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 10px;
  margin: 0;
  padding: 0 0 2px;
  border: 0;
  background: transparent;
}

.price-formula-row {
  display: flex;
  flex: 0 0 100%;
  width: 100%;
  align-items: center;
  flex-wrap: nowrap;
  white-space: nowrap;
  gap: 6px;
  min-width: 0;
}

.price-formula-row .el-input,
.price-formula-row .el-input-number {
  width: 110px;
  flex: 0 1 110px;
}

.price-formula-row .el-radio-group {
  flex-wrap: nowrap;
  white-space: nowrap;
}

.price-method-fields .el-radio-group {
  display: flex;
  gap: 12px;
}

.price-method-fields .el-radio,
.price-method-fields .el-radio__label {
  font-size: 12px;
}

.price-method-fields .el-input {
  width: 160px;
}

.price-number-input {
  width: 160px;
  height: 28px;
  display: inline-flex;
  vertical-align: middle;
  line-height: 28px;
}

.price-number-input .el-input-number__increase,
.price-number-input .el-input-number__decrease {
  width: 22px;
  right: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  line-height: 1;
  color: #606266;
  background: #f5f7fa;
  border-color: #dcdfe6;
}

.price-number-input .el-input-number__increase {
  top: 1px;
  height: 15px;
  border-radius: 0 3px 0 0;
}

.price-number-input .el-input-number__decrease {
  bottom: 1px;
  height: 15px;
  border-radius: 0 0 3px 0;
}

.price-number-input .el-input-number__increase i,
.price-number-input .el-input-number__decrease i {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 12px;
  line-height: 1;
}

.price-number-input .el-input-number__increase:hover,
.price-number-input .el-input-number__decrease:hover {
  color: var(--el-color-primary, #409eff);
  background: #ecf5ff;
}

.price-number-input .el-input__inner {
  padding-left: 15px;
  padding-right: 26px;
  text-align: left;
}

.price-tail-help {
  color: #8c98a8;
  cursor: help;
}

.price-method-fields .bm-title__match {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
}

.price-method-fields .bm-title__match button {
  border: 0;
  color: #f56c6c;
  background: transparent;
  cursor: pointer;
}

.price-method-fields > button {
  border: 1px solid #c8d2e3;
  border-radius: 3px;
  padding: 6px 10px;
  color: #245a9c;
  background: #fff;
  cursor: pointer;
}

.guard-options {
  padding: 12px 14px;
}

.guard-help {
  margin-left: 4px;
  color: #8c98a8;
  cursor: help;
}

.guard-tip {
  margin: 0 0 8px;
  color: #8c98a8;
  font-size: 11px;
  line-height: 18px;
}

.guard-row {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 8px;
  min-height: 30px;
  color: #666;
  font-size: 12px;
  white-space: nowrap;
}

.guard-row + .guard-row {
  margin-top: 8px;
}

.guard-row .price-number-input {
  width: 150px;
  flex: 0 0 150px;
}

.price-cell {
  min-width: 150px;
  line-height: 24px;
  white-space: nowrap;
}

@media (max-width: 700px) {
  .price-method {
    display: block;
  }

  .price-method-title {
    width: 100%;
    padding: 0;
  }

  .price-method-fields {
    margin-top: 8px;
  }
}

@media (max-width: 520px) {
  .sku-scope-options {
    padding: 0;
  }

  .sku-scope-config sku-scope-all-config,
  .price-method-fields {
    padding-left: 0;
  }

  .price-method-fields .el-radio-group {
    flex-wrap: nowrap;
  }

  .price-formula-row {
    gap: 2px;
    font-size: 12px;
  }
  .price-formula-row .el-input,
  .price-formula-row .el-input-number {
    width: 72px;
    flex-basis: 72px;
  }

  .price-number-input {
    width: 72px;
  }

  .price-number-input .el-input-number__increase,
  .price-number-input .el-input-number__decrease {
    width: 18px;
  }

  .price-number-input .el-input-number__increase i,
  .price-number-input .el-input-number__decrease i {
    font-size: 10px;
  }

  .price-number-input .el-input__inner {
    padding-left: 8px;
    padding-right: 21px;
  }

  .guard-options {
    padding: 10px 0;
  }

  .guard-row {
    gap: 4px;
  }

  .guard-row .price-number-input {
    width: 90px;
    flex-basis: 90px;
  }
}
</style>

